<template>
  <div>
    <DataTable :value="historicoCargos" :filters="filtro" :paginator="true" :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
        class="p-datatable-sm p-datatable-striped">
        <template #header>
            <div class="table-header">	
                <div class="p-d-flex p-jc-end">		                   									
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                    </span>
                </div>
            </div>
        </template>
        <Column field="cargo.id" header="Código"></Column>
        <Column field="cargo.nome" header="Cargo"></Column>   
        <Column field="dataInicio" header="Data início"></Column>
        <Column field="dataFinal" header="Data final"></Column>	        
        <Column>
            <template #body="slotProps">
                <div v-if="slotProps.data.dataFinal == null">
                    <Button icon="pi pi-plus" title="Novo cargo" class="p-button-rounded p-button-primary p-mr-2" @click="listarCargos('Novo')"/>
                    <Button icon="pi pi-pencil" title="Alterar cargo" class="p-button-rounded p-button-warning p-mr-2" @click="listarCargos('Alterar')"/>
                </div>					
            </template>
        </Column>
    </DataTable>

    <Button label="Fechar" class="p-button-secondary p-mt-3" icon="pi pi-times" @click="cancelar"/>

    <Dialog :visible.sync="exibirDialogNovoHistoricoCargo" header="Novo Cargo" :modal="true" class="p-fluid" :style="{width: '500px'}">			
        <div class="p-fluid p-formgrid p-grid">		
            <div class="p-field p-col-12 p-md-12">
                <label>Cargo atual</label>							
                <InputText v-model="funcionarioCargoAtual.cargo.nome" readonly/>							
            </div>			
            <div class="p-field p-col-12 p-md-12">
                <label>Novo cargo</label>							
                <Dropdown v-model="idCargoSelecionado" :filter="true" :options="cargos" 
                optionLabel="nome" optionValue="refId" dataKey="refId" appendTo="body"/>								
            </div>
            <div class="p-field p-col-12 p-md-12">
                <label for="dataInicioContrato">Data de início</label>
                <Calendar id="dataInicioContrato" v-model="dataInicioContrato" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" appendTo="body"/>	
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="trocarHistoricoCargo"/>
        </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogNovoCargo" header="Nova Cargo" :modal="true" class="p-fluid" :style="{width: '500px'}">			
        <div class="p-fluid p-formgrid p-grid">		
            <div class="p-field p-col-12 p-md-12">
                <label>Cargo atual</label>							
                <InputText v-model="funcionarioCargoAtual.cargo.nome" readonly/>							
            </div>			
            <div class="p-field p-col-12 p-md-12">
                <label>Novo cargo</label>							
                <Dropdown v-model="idCargoSelecionado" :filter="true" :options="cargos" 
                 optionLabel="nome" optionValue="refId" dataKey="refId" appendTo="body"/>								
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="trocarCargo"/>
        </template>
    </Dialog>

  </div>
</template>

<script>
import FuncionarioService from '@/service/FuncionarioService';
import CargoService from '@/service/CargoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    props: {
        historicoCargos: {
            type: Array,
            required: true,
            default: function() {
                return [];
            }
        },
        funcionario: {
            type:Object,
            required: true,
            default: function() {return {}}
        },
        callback: {
            type: Function,
            required: true,
        }
    },
    funcionarioService: null,
    cargoService: null,
    data() {        
        return {       
            exibirDialogNovoHistoricoCargo: false,
            exibirDialogNovoCargo: false,
            funcionarioCargoAtual: {cargo:{nome: ''}},
            idCargoSelecionado: null,
            cargoSelecionado: {},
            cargos: [],     
            filtro: {},
            dataInicioContrato: new Date(),
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']), 
        trocarHistoricoCargo() {
            for(let i = 0; i < this.cargos.length; i++) { 
                if(this.idCargoSelecionado == this.cargos[i].refId) {
                    this.cargoSelecionado = this.cargos[i];   
                    break;
                }
            }
            let requisicao = {
               idCargoNovo: this.cargoSelecionado.id,
               idCargoFuncionarioAntigo: this.funcionarioCargoAtual.id,
               dataInicio: this.formatarData(this.dataInicioContrato),
               ehHistorico: true,
               usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.trocarCargo(requisicao)
            .then(resp => {      
                exibirMensagem(this, resp);
                this.fecharModal();
                this.callback();
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        trocarCargo() {
            for(let i = 0; i < this.cargos.length; i++) { 
                if(this.idCargoSelecionado == this.cargos[i].refId) {
                    this.cargoSelecionado = this.cargos[i];   
                    break;
                }
            }
            console.log(this.idCargoSelecionado, this.cargoSelecionado)
            let requisicao = {      
                idCargoNovo: this.cargoSelecionado.id,
                idCargoFuncionarioAntigo: this.funcionarioCargoAtual.id,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.trocarCargo(requisicao)
            .then(resp => {      
                exibirMensagem(this, resp);
                this.fecharModal();
                this.callback();
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        listarCargos(acao) {
            let usuarioRequisicao = {...this.getDadosRequisicao()};         
            this.cargoService.listar(usuarioRequisicao)
				.then(resp => {                   
                    for(let i = 0; i < this.historicoCargos.length; i++) {
                        if(this.historicoCargos[i].dataFinal == null) {
                            this.funcionarioCargoAtual = this.historicoCargos[i];                            
                            break;
                        }
                    }
					this.cargos = resp.data;
                    this.cargos.forEach((cargo, i) => {
                        cargo['refId'] = i + '_' + cargo.id;
                    });
                    this.idCargoSelecionado = this.cargos[0].refId;
                    if(acao == 'Novo') {
                        this.exibirDialogNovoHistoricoCargo = true;            
                    } else {
                        this.exibirDialogNovoCargo = true;
                    }
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        fecharModal() {
            this.exibirDialogNovoHistoricoCargo = false;
            this.exibirDialogNovoCargo = false;
        },
        cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
    },	
	created() {
        this.funcionarioService = new FuncionarioService();	
        this.cargoService = new CargoService();	
	}
}
</script>

<style>

</style>